import type { GateSubmissionItem } from '../../hooks/gate/useGateScreenData'
import AppIcon from '../icons/AppIcon'
import Avatar from '../primitives/Avatar'
import styles from './GateScreen.module.css'

interface GateSubmissionGridProps {
  submissions: GateSubmissionItem[]
}

export default function GateSubmissionGrid({ submissions }: GateSubmissionGridProps) {
  if (submissions.length === 0) return null

  return (
    <>
      <div className={styles.section}>
        <span className={styles.eyebrow}>Submissions</span>
      </div>
      <div className={styles.subs}>
        {submissions.map((submission) => (
          <article
            key={submission.id}
            className={[styles.sub, submission.isYou && styles.subYou].filter(Boolean).join(' ')}
            data-testid="gate-submission"
          >
            <div className={styles.thumb}>
              {submission.isYou && <span className={styles.youTag}>You</span>}
              {submission.mediaUrl ? (
                submission.mediaType === 'video' ? (
                  <>
                    <video src={submission.mediaUrl} muted playsInline />
                    <span className={styles.play}>
                      <AppIcon icon="mdi:play" size={15} />
                    </span>
                  </>
                ) : (
                  <img src={submission.mediaUrl} alt="" />
                )
              ) : submission.mediaType === 'video' ? (
                <span className={styles.play}>
                  <AppIcon icon="mdi:play" size={15} />
                </span>
              ) : (
                <AppIcon icon="mdi:image-outline" size={26} />
              )}
            </div>
            <div className={styles.subFoot}>
              <Avatar
                initials={submission.initials}
                photoUrl={submission.photoUrl}
                size="xs"
              />
              <span className={styles.subName}>{submission.name}</span>
              <span className={styles.subTime}>{submission.time}</span>
            </div>
          </article>
        ))}
      </div>
    </>
  )
}
